import React from "react"
import {
  Box,
  Heading as HeadingChakra,
  chakra,
  Text as ChakraText,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react"
import { Text, FormControl, SubmitButton, Input } from "@src/shared/components"
import { Formik } from "formik"
import * as Yup from "yup"
import axios from "axios"

interface InitialValues {
  firstName?: string
  email: string
}

const initialValues: InitialValues = {
  firstName: "",
  email: "",
}

const validationSchema = Yup.object({
  firstName: Yup.string().required("This field is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("This field is required"),
})

export const ProductInfo = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const SubmitAnswer = async (values: InitialValues) => {
    try {
      const resp = await axios.post("/api/waitlistEmail", values)
      console.log(resp.data)
      onClose()
    } catch (err) {
      // Handle Error Here
      console.error(err)
    }
  }
  return (
    <Box>
      <Box position="sticky" top="0">
        <Box bg="white" p={5} height="auto">
          <HeadingChakra as="h1" fontSize="1.875rem" color="#5C5C5C">
            Nyame Nti
          </HeadingChakra>
          <ChakraText mt={3} fontSize="1.125rem" fontWeight="light">
            120 $CA
          </ChakraText>
          <Text type="small" mt={3}>
            <chakra.span as="i">‘Nyame Nti minnwe wura’</chakra.span>, ‘By God’s
            grace, I will not eat leaves to survive.’
          </Text>
          <Text type="small" mt={2}>
            Our design is inspired by the Adinkra symbol Nyame Nti which means
            “By God’s Grace”. The symbol represents faith and trust in God. It
            is the first pendant of our Adinkra collection, designed to bring
            African wisdom to you, to inspire and empower.
          </Text>
          <Button
            width="100%"
            mt={6}
            bg="#444444"
            _hover={{
              background: "#444444",
              color: "white",
            }}
            onClick={onOpen}
          >
            Join our waitlist
          </Button>
        </Box>
        <Accordion bg="#FFFCF7" mt={9}>
          <AccordionItem>
            <h2>
              <AccordionButton py={3}>
                <Box flex="1" textAlign="left">
                  <HeadingChakra
                    fontSize="0.875rem"
                    color="#5C5C5C"
                    fontWeight="regular"
                  >
                    Material
                  </HeadingChakra>
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              Our chain and pendant are made with high quality gold plated over
              925 Sterling Silver making this necklace a durable high quality
              piece of jewelry for everyday wear.
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem>
            <h2>
              <AccordionButton py={3}>
                <Box flex="1" textAlign="left">
                  <HeadingChakra
                    fontSize="0.875rem"
                    color="#5C5C5C"
                    fontWeight="regular"
                  >
                    Dimension
                  </HeadingChakra>
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <Text type="small" mt={2}>
                Adjustable chain 16 to 18 inch - The perfect length for any
                outfit.
              </Text>
              <Text type="small" mt={2}>
                Adjustable chain 18 to 20 inch - Perfect for layering along with
                your favorite necklaces.
              </Text>
              <Text type="small" mt={2}>
                Diameter: 16 mm.
              </Text>
              <Text type="small">Thickness: 1.3 mm.</Text>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Join our waitlist</ModalHeader>
          <ModalCloseButton />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={SubmitAnswer}
          >
            {({ handleSubmit }) => (
              <chakra.form onSubmit={handleSubmit}>
                <ModalBody>
                  <FormControl name="firstName">
                    <Input
                      size="lg"
                      placeholder="Enter your first name"
                      name="firstName"
                      label="First Name"
                    />
                  </FormControl>
                  <FormControl name="email" mt={4}>
                    <Input
                      size="lg"
                      placeholder="Enter your email"
                      name="email"
                      label="Email address"
                    />
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <SubmitButton
                    bg="#444444"
                    _hover={{
                      background: "#444444",
                      color: "white",
                    }}
                  >
                    Submit
                  </SubmitButton>
                </ModalFooter>
              </chakra.form>
            )}
          </Formik>
        </ModalContent>
      </Modal>
    </Box>
  )
}
